import { render, staticRenderFns } from "./HomeworkPreview.vue?vue&type=template&id=626e0142&scoped=true&lang=pug&"
import script from "./HomeworkPreview.vue?vue&type=script&lang=js&"
export * from "./HomeworkPreview.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkPreview.vue?vue&type=style&index=0&id=626e0142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626e0142",
  null
  
)

export default component.exports